import { Card, Dropdown } from "flowbite-react"
import { Link, useNavigate } from "react-router-dom"
import ARTE_CAN from "../../assets/images/ARTE_CAN.png"
import ARTA_CAN from "../../assets/images/ARTA_CAN.png"

const NavbarCoursesDropdown = () => {
  const navigate = useNavigate()
  return (
    <Dropdown
      label="Courses"
      arrowIcon={true}
      inline={true}
      placement="bottom"
      trigger="hover"
      theme={{
        arrowIcon: "ml-2 h-4 w-4",
        content: "py-1 focus:outline-none",
        floating: {
          animation: "transition-opacity",
          arrow: {
            base: "absolute z-10 h-2 w-2 rotate-45",
            style: {
              dark: "bg-neutral-900 dark:bg-neutral-700",
              light: "bg-white",
              auto: "bg-white dark:bg-neutral-700",
            },
            placement: "-4px",
          },
          base: "z-10 w-fit rounded divide-y divide-neutral-100 shadow focus:outline-none",
          content: "py-1 text-sm text-neutral-700 dark:text-neutral-200",
          divider: "my-1 h-px bg-neutral-100 dark:bg-neutral-600",
          header:
            "block py-2 px-4 text-sm text-neutral-700 dark:text-neutral-200",
          hidden: "invisible opacity-0",
          item: {
            container: "",
            base: "flex items-center justify-start py-2 px-4 text-sm text-neutral-700 cursor-pointer w-full hover:bg-neutral-100 focus:bg-neutral-100 dark:text-neutral-200 dark:hover:bg-neutral-600 focus:outline-none dark:hover:text-white dark:focus:bg-neutral-600 dark:focus:text-white",
            icon: "mr-2 h-4 w-4",
          },
          style: {
            dark: "bg-neutral-900 text-white dark:bg-neutral-800",
            light: "border border-neutral-200 bg-white text-neutral-900",
            auto: "border border-neutral-200 bg-white text-neutral-900 dark:border-none dark:bg-neutral-800 dark:text-white",
          },
          target: "w-fit",
        },
        inlineWrapper:
          "flex py-2 pr-4 pl-3 md:p-0 border-b border-neutral-100 items-center hover:bg-neutral-50 dark:border-neutral-700 text-white dark:hover:bg-neutral-700 hover:text-neutral-400 md:border-0 md:hover:bg-transparent md:hover:text-neutral-400 md:dark:hover:bg-transparent font-bold uppercase font-hacktricks",
      }}
    >
      {/* TODO do we want to generate this list from the API? */}
      <Dropdown.Item
        onClick={() => {
          navigate("/courses/arte")
        }}
        theme={{
          base: "flex w-full items-center justify-start text-sm text-gray-800 cursor-pointer hover:bg-neutral-100 dark:text-gray-200 dark:hover:bg-neutral-500 dark:hover:text-white",
        }}
      >
        <Card
          horizontal={true}
          imgSrc={ARTE_CAN}
          className="dark:bg-neutral-800 items-center rounded-none border-0 shadow-none hover:dark:bg-neutral-700"
          theme={{
            img: {
              base: "h-48 w-48 rounded-t-lg object-cover  md:w-48 md:rounded-none md:rounded-l-lg mt-3 md:mt-0",
              horizontal: {
                on: "h-48 w-48 rounded-t-lg object-cover  md:w-48 md:rounded-none md:rounded-l-lg mt-3 md:mt-0",
              },
            },
          }}
        >
          <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
            AWS Red Team Expert
          </h5>
          <p className="font-normal text-gray-700 dark:text-gray-400">
            Starting from the basics deepen your expertise in AWS security with
            a comprehensive exploration of advanced concepts, including in-depth
            identity and access management strategies, encryption methods, and
            sophisticated networking defenses. Master the application of
            specialized red team tactics in AWS contexts, enabling the detection
            and correction of complex security flaws.
          </p>
        </Card>
      </Dropdown.Item>
      <Dropdown.Item
        onClick={() => {
          navigate("/courses/arta")
        }}
        theme={{
          base: "flex w-full items-center justify-start text-sm text-gray-800 cursor-pointer hover:bg-neutral-100 dark:text-gray-200 dark:hover:bg-neutral-500 dark:hover:text-white",
        }}
      >
        <Card
          horizontal={true}
          imgSrc={ARTA_CAN}
          className="dark:bg-neutral-800 items-center rounded-none border-0 shadow-none hover:dark:bg-neutral-700"
          theme={{
            img: {
              base: "h-48 w-48 rounded-t-lg object-cover  md:w-48 md:rounded-none md:rounded-l-lg mt-3 md:mt-0",
              horizontal: {
                on: "h-48 w-48 rounded-t-lg object-cover  md:w-48 md:rounded-none md:rounded-l-lg mt-3 md:mt-0",
              },
            },
          }}
        >
          <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
            AWS Red Team Apprentice
          </h5>
          <p className="font-normal text-gray-700 dark:text-gray-400">
            Start your journey in AWS security, focusing on foundational
            concepts like basic access controls, introductory data protection
            techniques, and network security essentials. Discover how to utilize
            red team approaches within AWS to spot and fix complex security
            issues in the most common AWS services.
          </p>
        </Card>
      </Dropdown.Item>
      <Link
        to="/courses"
        className="flex mx-5 py-2 text-neutral-800 dark:text-neutral-400 hover:text-red-logo dark:hover:text-red-logo"
      >
        View all courses
      </Link>
    </Dropdown>
  )
}

export default NavbarCoursesDropdown
